import React from 'react';
import c from '../w.js';

const IconArrowsVertical = React.memo(
  c(
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M7 14.0002V6.41436L3.70711 9.70726L2.29289 8.29304L8 2.58594L13.7071 8.29304L12.2929 9.70726L9 6.41436V14.0002H7Z" }), /* @__PURE__ */ React.createElement("path", { d: "M15 10L15 17.5858L11.7071 14.2929L10.2929 15.7071L16 21.4142L21.7071 15.7071L20.2929 14.2929L17 17.5858L17 10H15Z" }))
  )
);

export { IconArrowsVertical };
